import React, { Component } from 'react';
import PropTypes from 'prop-types';

const TicketsHOC = (C) => {
  class TicketsComp extends Component {
    static show(props) {
      if (!props.order.services) {
        return false;
      }

      const ticketGroups = this.getTicketGroups(props.order);

      return !!Object.keys(ticketGroups).length;
    }

    static getTicketGroups(props) {
      const ticketGroups = {};

      /* eslint-disable array-callback-return */
      props.services.map((service) => {
        if (service.serviceGroup === 301 && service.subGroup !== null && service.type !== 'OWNER') {
          ticketGroups[service.subGroup] = ticketGroups[service.subGroup] || [];
          ticketGroups[service.subGroup].push(service);
        }
      });
      /* eslint-enable array-callback-return */

      return ticketGroups;
    }

    render() {
      if (!TicketsComp.show(this.props)) {
        return null;
      }

      const ticketGroups = TicketsComp.getTicketGroups(this.props.order);

      return (
        <C
          actions={this.props.actions}
          onChange={this.props.actions.updateTickets}
          order={this.props.order}
          ticketGroups={ticketGroups}
        />
      );
    }
  }

  TicketsComp.PropTypes = {
    order:PropTypes.shape({
      services:PropTypes.array,
    }).isRequired,
    actions:PropTypes.shape({
      updateTickets:PropTypes.func.isRequired,
    }).isRequired,
  };

  return TicketsComp;
};

export default TicketsHOC;
